import React, { Fragment, useEffect, useState } from "react";
import ActionButton from "../../../components/Buttons/ActionButton";
import NavigationButton from "../../../components/Buttons/NavigationButton";
import SubMenu from "../../../components/SubMenu";
import { ReactComponent as DragIcon } from "../../../assets/icons/drag_indicator.svg";
import { ReactComponent as BlockIcon } from "../../../assets/icons/block.svg";
import { ReactComponent as ArrowDownIcon } from "../../../assets/icons/arrow_down.svg";
import { ReactComponent as SaveIcon } from "../../../assets/icons/save.svg";
import { ReactComponent as ZoomInIcon } from "../../../assets/icons/zoom_in.svg";
import { ReactComponent as ZoomOutIcon } from "../../../assets/icons/zoom_out.svg";
import { ReactComponent as UndoIcon } from "../../../assets/icons/undo.svg";
import { ReactComponent as RedoIcon } from "../../../assets/icons/redo.svg";
import { ReactComponent as PlayIcon } from "../../../assets/icons/play.svg";
import { ReactComponent as PauseIcon } from "../../../assets/icons/pause.svg";
import { ReactComponent as AddItemIcon } from "../../../assets/icons/add.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
import { ReactComponent as SystemIcon } from "../../../assets/icons/system.svg";
import { ReactComponent as SettingIcon } from "../../../assets/icons/block-setting.svg";
import { ReactComponent as LogicIcon } from "../../../assets/icons/logic.svg";
import { ReactComponent as MovementIcon } from "../../../assets/icons/movement.svg";
import { ReactComponent as AIIcon } from "../../../assets/icons/ai.svg";
import useModal from "../Program/useModal.js";

import UserService from "../../../services/UserService";
import { useStoreApi, useReactFlow } from "react-flow-renderer";
import {
  useActionGroups,
  useActionsGroupedByBlockLibrary,
  useProgram,
  useProgramDone,
  useDevices,
} from "../../../Api/newSockets.api";
import useCheckMobileScreen from "../../../hooks/useCheckScreen";

type SidebarProps = {
  updateElements?: Function;
  program?: any;
  scope?: any;
  onSave: any;
  onAdd: any;
  runProgram: any;
  running: boolean;
  selectedDeviceId?: number | null;
  onDeviceChange?: (deviceId: number | null) => void;
};

const mapActionToBlock = (action) => {
  return {
    id: action.id,
    name: action.name,
    inputs: [...action.inputs],
    outputs: [...action.outputs],
    deviceTypeId: action.deviceTypeId,
    deviceTypes: action.deviceTypes,
    deviceId: null,
    type: action.nodeTypes.name,
    runtime: 0,
  };
};
const ProgramSidebar = (props: SidebarProps) => {
  const { actionGroups } = useActionGroups();
  const { actionsGroupedByBlockLibrary } = useActionsGroupedByBlockLibrary();
  const { devices } = useDevices();
  // const { isShowing, openModal, closeModal } = useModal();
  const [modalOpen, setModalOpen] = useState(false);


  const isMobile = useCheckMobileScreen();
  // const [scope, setScope] = useState(UserService.scope);

  // const store = useStoreApi();
  const { zoomIn, zoomOut, setCenter } = useReactFlow();

  // const nodes = useStoreState((store) => store.nodes);

  // const transform = useStoreState((store) => store.transform);
  // const setSelectedElements = useStoreActions((actions) => actions.setSelectedElements);

  const onDragStart = (event, nodeType, nodeData) => {
    event.dataTransfer.setData("node/type", nodeType);
    event.dataTransfer.setData("node/data", JSON.stringify(nodeData));
    event.dataTransfer.effectAllowed = "move";
  };

  const onSave = () => {
    props.onSave();
  };

  return (
    <div className="program-sidebar">
      <div className="program-toolbar-container">
        <div className="program-title">
          <div style={{ minWidth: "80px" }}>
            <NavigationButton
              className="back-btn"
              icon={<ArrowDownIcon />}
              to="/develop/programs"
            />
            {props.program && props.program.name}
          </div>
        </div>
        {props.program ? (
          props.program.description && (
            <div className="program-desc">{props.program.description}</div>
          )
        ) : (
          <></>
        )}

        {/* Device Selection Dropdown */}
        <div style={{ padding: '0.5rem 1rem', borderBottom: '1px solid rgba(83, 189, 228, 0.2)' }}>
          <label style={{
            display: 'block',
            fontSize: '0.75rem',
            color: '#53bde4',
            marginBottom: '0.5rem',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            Target Device
          </label>
          <select
            value={props.selectedDeviceId || ''}
            onChange={(e) => props.onDeviceChange?.(e.target.value ? Number(e.target.value) : null)}
            style={{
              width: '100%',
              padding: '0.6rem',
              background: '#21282c',
              border: '2px solid #53bde4',
              borderRadius: '6px',
              color: '#fff',
              fontSize: '0.85rem',
              fontWeight: '500',
              cursor: 'pointer',
              outline: 'none',
            }}
          >
            <option value="" style={{ background: '#21282c', color: '#888' }}>
              Select Device
            </option>
            {devices && devices
              .filter((device: any) => device.deviceTypes.id === 1)
              .map((device: any) => (
                <option key={device.id} value={device.id} style={{ background: '#21282c', color: '#fff' }}>
                  {device.name || `Device ${device.id}`}
                </option>
              ))}
          </select>
        </div>

        <div className="program-icons">
          <ActionButton
            icon={<SaveIcon />}
            onClick={onSave}
            className="program-button"
          />
          <ActionButton icon={<UndoIcon />} className="program-button" />
          <ActionButton icon={<RedoIcon />} className="program-button" />
          <ActionButton icon={<ZoomInIcon />} className="program-button" />
          <ActionButton icon={<ZoomOutIcon />} className="program-button" />
        </div>
      </div>
      <div className="program-block-container">
        <SubMenu
          title="Block Properties"
          expands={false}
          className="block-properties"
        >
          {
            <Fragment>
              {/* <div className="selected-action-name">{this.selectedBlock.action.name}</div> */}
              <form className="selected-action"></form>
            </Fragment>
          }
          {/* {  
            this.selectedBlock  && <Fragment>
                <div className="selected-action-name">{this.selectedBlock.action.name}</div>
                <form className="selected-action" onSubmit={(e)=>this.submitChanges(e, this.selectedBlock)}>
                { 
                    this.selectedBlock.action.inputs.map((input:any, i:any) =>
                    <div className="action-input" key={i}> 
                        <label>{input.name}</label>
                        {
                            this.renderSwitch(input.type, input.value, input.options)
                        }
                    </div>
                    )}
                {
                    this.selectedBlock.action.type === BlockType.custom && <button type="submit">Update</button>
                }
                </form>
                </Fragment>
            } */}
        </SubMenu>

        <SubMenu title="Library" 
          expands={modalOpen} 
          onToggle={(state) => setModalOpen(state)}
          actions={<button
            onClick={() => setModalOpen(true)}
            className="submenu-block-button"
            type="button"
          >
            + block
          </button>}
        >
          {/* {actionGroups && 
                    <div className="action-list" >
                        {actionGroups?.map((type:any, i:any) => {
                            return (
                                <div key={i} className="type-container">
                                    <h5>{type.name}</h5> 
                                    {type.actions?.map((action:any, y:any) => {
                                        return (
                                            <div key={y} className="libnode output action" onDragStart={(event) => onDragStart(event, action.nodeTypes.name, mapActionToBlock(action))}  onTouchStart={(event) => onDragStart(event, action.nodeTypes.name, mapActionToBlock(action))} draggable>
                                                <div className="drag-icon">
                                                    <BlockIcon className={action.deviceTypeId} />
                                                </div>
                                                <div className="action-name">{action.name}</div>
                                                <ActionButton icon={<AddItemIcon />} className="sidebar-blocks" onClick={e => props.onAdd({data: mapActionToBlock(action), type:action.nodeTypes.name })}/>
                                            </div>
                                        )
                                    })}
                        
                                </div>
                            )
                        })}
                    </div>
                    } */}
          {actionGroups && (
            // <div className="block-modal">
            // <div className="block-modal-content-container">
            // {/* <div className="block-modal-close-icon-container">
            //     <CloseIcon
            //       className="block-modal-close-icon-button"
            //       onClick={closeModal}
            //     />
            //   </div> */}
            <div className="block-modal-flex-container">
              {/* <div className="block-modal-left">
                <h4>Block Library</h4>

                <div className="container-logo__text">
                  <div className="icon-container">
                    <SystemIcon className="fill--blue" />
                  </div>
                  <div>
                    <p className="list-of-items">System</p>
                  </div>
                </div>
                <div className="container-logo__text">
                  <div className="icon-container">
                    <SettingIcon />
                  </div>
                  <div>
                    <p className="list-of-items">General</p>
                  </div>
                </div>
                <div className="container-logo__text">
                  <div className="icon-container">
                    <LogicIcon />
                  </div>
                  <div>
                    <p className="list-of-items">Logic</p>
                  </div>
                </div>
                <div className="container-logo__text">
                  <div className="icon-container">
                    <MovementIcon />
                  </div>
                  <div>
                    <p className="list-of-items">Movement</p>
                  </div>
                </div>
                <div className="container-logo__text">
                  <div className="icon-container">
                    <AIIcon />
                  </div>
                  <div>
                    <p className="list-of-items">Ai</p>
                  </div>
                </div>
              </div> */}
              <div className="block-modal-right">
                <h4 style={{marginBottom: 0}}>Block Library</h4>
                {/* <input
                  placeholder="Search..."
                  className="modal-search-input-component"
                /> */}
                {actionsGroupedByBlockLibrary?.map((library: any, i: any) => {

                  return (
                    <div key={i} className="block-modal-item-container">
                      <h5 className="modal-action-name">{library.name}</h5>
                      <div className="block-modal-functions-container">
                        {library.actions?.map((action: any, y: any) => {
                          return (
                            <div
                              key={y}
                              className="block-modal-functions"
                              onClick={(e) =>
                                props.onAdd({
                                  data: mapActionToBlock(action),
                                  type: action.nodeTypes.name,
                                })
                              }
                            >
                              <div
                                
                                className="block-modal-functions-content"
                                onDragStart={(event) =>
                                  onDragStart(
                                    event,
                                    action.nodeTypes.name,
                                    mapActionToBlock(action)
                                  )
                                }
                                onTouchStart={(event) =>
                                  onDragStart(
                                    event,
                                    action.nodeTypes.name,
                                    mapActionToBlock(action)
                                  )
                                }
                                draggable
                                onClick={() => setModalOpen(false)}
                              >
                                <div className="drag-icon">
                                  <BlockIcon />
                                </div>
                                <div className="modal-action-info">
                                  <div className="action-name">{action.name}</div>
                                  <div className="action-device-name">{action.deviceTypes?.name}</div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            // {/* </div> */}
            // {/* </div> */}
          )}
        </SubMenu>
        <SubMenu title="Variables" expands={false}>
          {props.scope ? (
            <div className="action-list">
              {props.scope.map((variable, key) => {
                return (
                  <div className="action" draggable="true" key={key}>
                    <div className="drag-icon">
                      <DragIcon />
                    </div>
                    <div className="action-name">{variable}</div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p style={{ fontSize: "0.8rem" }}>No variables</p>
          )}
        </SubMenu>
      </div>
    </div>
  );
};

export default ProgramSidebar;
